import { render, staticRenderFns } from "./ChartShowcase.vue?vue&type=template&id=50140221&scoped=true"
import script from "./ChartShowcase.vue?vue&type=script&lang=js"
export * from "./ChartShowcase.vue?vue&type=script&lang=js"
import style0 from "./ChartShowcase.vue?vue&type=style&index=0&id=50140221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50140221",
  null
  
)

export default component.exports